var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-title" }, [
          _c("span", { style: { color: _vm.fontColor } }, [
            _vm._v(" 專業技能及認證 "),
            _c("span", { staticClass: "en-text" }, [
              _vm._v("Professional skills and certification"),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "field-value" },
          [
            _c("el-input", {
              staticClass: "w-100",
              attrs: {
                type: "textarea",
                rows: 6,
                maxlength: "10000",
                "show-word-limit": "",
              },
              model: {
                value: _vm.skill.ProfessionalSkill,
                callback: function ($$v) {
                  _vm.$set(_vm.skill, "ProfessionalSkill", $$v)
                },
                expression: "skill.ProfessionalSkill",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "edit-btn-wrap" }, [
        _c(
          "button",
          {
            staticClass: "put-btn",
            attrs: { type: "button" },
            on: { click: _vm.saveSkill },
          },
          [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }